import { $api } from "../../shared/api";
import { Token } from "./model";

export const adminSignin = (username: string, password: string) => {
  return $api.post("admin/signin", {
    username,
    password,
  });
};
export const adminInfo = (token: Token) => {
  // we already set our token in interceptors
  return $api.post("admin/user_info");
};
